module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_01_6NX26_1SF_GLR.c807a072.png";